export default (() => {
  String.prototype.getValueWithPenny = () => {
    if (!this) {
      return 0;
    }

    const value = this.replace(/\s/g, '');

    return parseFloat(value) * 10 * 10;
  };
})();
